import { render, staticRenderFns } from "./abnormal_list.vue?vue&type=template&id=74a79816&scoped=true"
import script from "./abnormal_list.vue?vue&type=script&lang=js"
export * from "./abnormal_list.vue?vue&type=script&lang=js"
import style0 from "./abnormal_list.vue?vue&type=style&index=0&id=74a79816&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a79816",
  null
  
)

export default component.exports